module.exports = __webpack_public_path__ + "SL.png?ff066061e1cad9a4dfa08f0942a72a02";